module.exports = __webpack_public_path__ + "media/images/associate_job_logo-8fe972857a229789908c396329a5a48b.png";